module.exports = __webpack_public_path__ + "static/media/Akaeze Gallery.png.1ffa663a.jpg";